import * as CryptoJS from "crypto-js";

export const encryptAES = (text:any,keys:any) => 
  {
    return CryptoJS.AES.encrypt(text,keys).toString();
  };

export const decryptAES = (cipher:any,keys:any) => {
    const splitString = cipher.split(",");
    const m = splitString.map((a:any) => {
      return CryptoJS.AES.decrypt(a, keys).toString(CryptoJS.enc.Utf8);
    });
    return m[0];
  };